/**
 * Apartsales — Legacy route `/unit/$id` (UUID-based).
 *
 * **Backwards-compat redirect** на новый slug-URL стандарт (§2.4 ТЗ).
 *
 * Старые ссылки `/unit/UUID` всё ещё могут существовать (закладки, share).
 * При заходе на /unit/UUID:
 *   1. Резолвит UUID → UnitCard DTO
 *   2. Строит slug-URL по DTO через buildSlugUrl()
 *   3. navigate({ replace: true }) на новый URL
 */

import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

import { fetchUnitCard } from '~/lib/unit-card-api';
import { buildSlugUrl } from '~/lib/slug-routing';

export const Route = createFileRoute('/unit/$id')({
  component: UnitLegacyRedirect,
});

function UnitLegacyRedirect() {
  const { id } = Route.useParams();
  const navigate = useNavigate();

  const { data, isLoading } = useQuery({
    queryKey: ['unit-card', id],
    queryFn: () => fetchUnitCard(id),
    staleTime: 60_000,
  });

  useEffect(() => {
    if (data) {
      const slugUrl = buildSlugUrl(data);
      navigate({ to: slugUrl, replace: true });
    }
  }, [data, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center px-6 text-center">
      <div className="text-[14px] text-label-2">
        {isLoading ? 'Загрузка…' : 'Перенаправление…'}
      </div>
    </div>
  );
}
